// Date formatting utilities
import dayjs from 'dayjs';

// The single, canonical display formats used everywhere in the UI.
// Storage / API / <input type="date"> keep using ISO (YYYY-MM-DD); these are
// only for what the user sees.
const DISPLAY_DATE = 'DD MMM YYYY';           // e.g. 01 Jul 2026
const DISPLAY_DATETIME = 'DD MMM YYYY, HH:mm'; // e.g. 01 Jul 2026, 20:29

export const formatDateForBackend = (dateString) => {
  if (!dateString) return '';
  
  // Try parsing as ISO format (YYYY-MM-DD)
  const isoMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (isoMatch) {
    return dateString; // Already in correct format
  }
  
  // Parse slash-separated dates as DD/MM/YYYY (the locale this app is used in).
  // NOTE: DD/MM and MM/DD share the same regex and cannot be told apart from the
  // string alone, so we intentionally assume DD/MM here rather than keeping a
  // second, unreachable MM/DD branch.
  const dmyMatch = dateString.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (dmyMatch) {
    return `${dmyMatch[3]}-${dmyMatch[2]}-${dmyMatch[1]}`;
  }

  return dateString; // Fallback to original if format not recognized
};

export const formatDateForInput = (dateString) => {
  if (!dateString) return '';
  return dateString.split('T')[0]; // Convert to YYYY-MM-DD format
};

// Canonical date display, e.g. "01 Jul 2026". Accepts ISO dates
// ("2026-07-01") and ISO datetimes ("2026-07-01T08:51:31.283Z").
export const formatDisplayDate = (dateString) => {
  if (!dateString) return '-';
  const d = dayjs(dateString);
  return d.isValid() ? d.format(DISPLAY_DATE) : '-';
};

// Canonical date + time display, e.g. "01 Jul 2026, 20:29" (24h).
export const formatDisplayDateTime = (dateString) => {
  if (!dateString) return '-';
  const d = dayjs(dateString);
  return d.isValid() ? d.format(DISPLAY_DATETIME) : '-';
};
